import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from './slices/authSlice';
import { bootSlice } from './slices/bootSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    boot: bootSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
